var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgM04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5292 3.66734L10.1342 1.70984C9.48922 1.42484 8.51422 1.42484 7.86922 1.70984L3.47422 3.66734C2.36422 4.16234 2.19922 4.83734 2.19922 5.19734C2.19922 5.55734 2.36422 6.23234 3.47422 6.72734L7.86922 8.68484C8.19172 8.82734 8.59672 8.90234 9.00172 8.90234C9.40672 8.90234 9.81172 8.82734 10.1342 8.68484L14.5292 6.72734C15.6392 6.23234 15.8042 5.55734 15.8042 5.19734C15.8042 4.83734 15.6467 4.16234 14.5292 3.66734Z",
    fill: "#0e131c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99828 12.78C8.71328 12.78 8.42828 12.72 8.16578 12.6075L3.11078 10.3575C2.33828 10.0125 1.73828 9.09 1.73828 8.2425C1.73828 7.935 1.98578 7.6875 2.29328 7.6875C2.60078 7.6875 2.84828 7.935 2.84828 8.2425C2.84828 8.6475 3.18578 9.1725 3.56078 9.3375L8.61578 11.5875C8.85578 11.6925 9.13328 11.6925 9.37328 11.5875L14.4283 9.3375C14.8033 9.1725 15.1408 8.655 15.1408 8.2425C15.1408 7.935 15.3883 7.6875 15.6958 7.6875C16.0033 7.6875 16.2508 7.935 16.2508 8.2425C16.2508 9.0825 15.6508 10.0125 14.8783 10.3575L9.82328 12.6075C9.56828 12.72 9.28328 12.78 8.99828 12.78Z",
    fill: "#0e131c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99828 16.5002C8.71328 16.5002 8.42828 16.4402 8.16578 16.3277L3.11078 14.0777C2.27828 13.7102 1.73828 12.8777 1.73828 11.9627C1.73828 11.6552 1.98578 11.4077 2.29328 11.4077C2.60078 11.4077 2.84828 11.6552 2.84828 11.9627C2.84828 12.4352 3.12578 12.8627 3.56078 13.0577L8.61578 15.3077C8.85578 15.4127 9.13328 15.4127 9.37328 15.3077L14.4283 13.0577C14.8558 12.8702 15.1408 12.4352 15.1408 11.9627C15.1408 11.6552 15.3883 11.4077 15.6958 11.4077C16.0033 11.4077 16.2508 11.6552 16.2508 11.9627C16.2508 12.8777 15.7108 13.7027 14.8783 14.0777L9.82328 16.3277C9.56828 16.4402 9.28328 16.5002 8.99828 16.5002Z",
    fill: "#0e131c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM04);
export default __webpack_public_path__ + "static/media/m_04.30bfb6b2d02e227cf1c518e43b76e9d5.svg";
export { ForwardRef as ReactComponent };